// v1 Meta Conversions API. Schemas in api-meta-capi.ts.
import * as M from './api-meta-capi.js';
import { items, route, Ws } from './route-def.js';

export const metaCapiRoutes = {
  getMetaCapiSettings: route({
    method: 'GET', path: '/workspaces/:workspaceId/meta-capi', summary: 'Meta Conversions API: dataset, eventos y estado', tag: 'integrations',
    minRole: 'manager', module: null, params: Ws, response: M.MetaCapiSettingsSchema,
  }),
  putMetaCapiSettings: route({
    method: 'PUT', path: '/workspaces/:workspaceId/meta-capi', summary: 'Configurar Meta Conversions API (el token no se devuelve)', tag: 'integrations',
    minRole: 'admin', module: null, params: Ws, body: M.PutMetaCapiSettingsSchema, response: M.MetaCapiSettingsSchema,
  }),
  testMetaCapi: route({
    method: 'POST', path: '/workspaces/:workspaceId/meta-capi/test', summary: 'Enviar un evento de prueba (test_event_code)', tag: 'integrations',
    minRole: 'admin', module: null, params: Ws, response: M.MetaCapiTestResultSchema,
  }),
  listMetaCapiEvents: route({
    method: 'GET', path: '/workspaces/:workspaceId/meta-capi/events', summary: 'Eventos enviados a Meta (aceptados, fallidos, pendientes)', tag: 'integrations',
    minRole: 'manager', module: null, params: Ws, response: items(M.MetaCapiEventSchema),
  }),
};
